export default __webpack_public_path__ + "images/a4520f7eff03ac85a3715e047cc1435c.svg";